import { render, staticRenderFns } from "./LFSQuestionAnswerFilter.vue?vue&type=template&id=037d8096&scoped=true"
import script from "./LFSQuestionAnswerFilter.vue?vue&type=script&lang=js"
export * from "./LFSQuestionAnswerFilter.vue?vue&type=script&lang=js"
import style0 from "./LFSQuestionAnswerFilter.vue?vue&type=style&index=0&id=037d8096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d8096",
  null
  
)

export default component.exports